import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "level-progress" }
const _hoisted_2 = { class: "level-progress__track" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueProgressBar',
  props: {
    progress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "level-progress__fill",
        style: _normalizeStyle({ width: `${_ctx.progress}%` })
      }, null, 4)
    ])
  ]))
}
}

})